import {
  IMenuQrStickerRotation,
  IMenuQrStickerSettings,
} from '@/interfaces/IMenuQrStickerSettings';
import { IMenuQrLayoutProfile } from './menu-qr-layout';

export interface IMenuQrStickerLayoutInput {
  /** Layout space: label dimensions are swapped for quarter-turn rotations. */
  profile: IMenuQrLayoutProfile;
  pxPerMm: number;
  rotation: IMenuQrStickerRotation;
  finalWidthMm: number;
  finalHeightMm: number;
}

/** Maps the printer's sticker settings (mm at dpmm) to the shared layout profile. */
export function stickerSettingsToLayoutInput(
  settings: IMenuQrStickerSettings
): IMenuQrStickerLayoutInput {
  const isQuarterTurn = settings.rotation === 90 || settings.rotation === 270;

  return {
    profile: {
      widthMm: isQuarterTurn ? settings.labelHeightMm : settings.labelWidthMm,
      heightMm: isQuarterTurn ? settings.labelWidthMm : settings.labelHeightMm,
      padding: { ...settings.padding },
      offsetXMm: settings.offsetXMm,
      offsetYMm: settings.offsetYMm,
      qrScale: settings.qrScale,
      titleFontSizeMm: settings.titleFontSizeMm,
      titleGapMm: settings.titleGapMm,
      logoSizeMm: settings.logoSizeMm,
      logoOffsetMm: settings.logoOffsetMm,
      footerWidthMm: settings.footerWidthMm,
      footerOffsetBottomMm: settings.footerOffsetBottomMm,
    },
    pxPerMm: settings.dpmm,
    rotation: settings.rotation,
    finalWidthMm: settings.labelWidthMm,
    finalHeightMm: settings.labelHeightMm,
  };
}
